import React, { useState, useEffect } from "react";
import { TableBuilder, TableBuilderColumn } from "baseui/table-semantic";
import DynamicPagination from "../dynamic-navigation/DynamicPaginationComponent";

const PaginatedTable = ({
  data,
  columns,
  nextToken,
  onNext,
  onPrev,
  refresh = false,
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [tokens, setTokens] = useState([null]); // Initialize with the starting page token
  useEffect(() => {
    if (data.length === 0 && refresh) {
      setTokens([null]);
      setCurrentPage(1);
    }
  }, [data, refresh]);
  const handleNextPage = () => {
    const nextPage = currentPage + 1;
    setCurrentPage(nextPage);
    if (nextPage > tokens.length) {
      // If moving beyond the known tokens
      if (!tokens.includes(nextToken)) {
        // Check if the token is not already in the stack
        setTokens((prevTokens) => [...prevTokens, nextToken]); // Add new token
      }
      onNext(nextToken); // Fetch data with the next token
    } else {
      // If the token already exists for the page, use it without fetching new data
      onNext(tokens[nextPage - 1]);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      const newCurrentPage = currentPage - 1;
      setCurrentPage(newCurrentPage);
      onPrev(tokens[newCurrentPage - 1]);
    }
  };

  return (
    <>
      <TableBuilder
        size="compact"
        divider="horizontal"
        overrides={{
          TableHeadCell: {
            style: ({ $theme }) => ({
              minWidth: "100px", // Example minimum width; adjust as needed
            }),
          },
        }}
        data={data}
      >
        {columns.map((column, index) => (
          <TableBuilderColumn key={index} header={column.header}>
            {column.cell}
          </TableBuilderColumn>
        ))}
      </TableBuilder>
      <DynamicPagination
        hasNext={
          currentPage < tokens.length ||
          (nextToken && tokens[tokens.length - 1] !== nextToken)
        }
        hasPrev={currentPage > 1}
        currentPage={currentPage}
        onPrevClick={handlePrevPage}
        onNextClick={handleNextPage}
      />
    </>
  );
};

export default PaginatedTable;
